export interface Job {
  slug: string;
  title: string;
  location: string;
  type: string;
  about: string;
  responsibilities: string[];
  requirements: string[];
  offering: string[];
}

export const jobs: Job[] = [
  {
    slug: "gas-technician-dcd-certified",
    title: "Gas Technician (DCD Certified)",
    location: "Dubai",
    type: "Full-time",
    about:
      "We are looking for a DCD-certified Gas Technician to join our field operations team. You will be responsible for the installation, maintenance, and inspection of gas piping systems across residential and commercial projects in the UAE.",
    responsibilities: [
      "Install and maintain LPG/SNG piping systems in compliance with DCD standards",
      "Conduct pressure testing, leak detection, and safety inspections",
      "Respond to emergency gas leak reports and perform corrective actions",
      "Maintain accurate records of all installations and inspections",
      "Coordinate with project managers and clients on site requirements",
    ],
    requirements: [
      "Valid DCD Technician License",
      "Minimum 3 years of experience in gas installation and maintenance",
      "Knowledge of UAE gas safety regulations and ESMA standards",
      "Strong problem-solving and communication skills",
      "Valid UAE driving license",
    ],
    offering: [
      "Competitive salary aligned with UAE market standards",
      "Comprehensive medical insurance",
      "Annual performance bonuses",
      "DCD license renewal support and ongoing training",
      "Career advancement opportunities within GASIS",
    ],
  },
  {
    slug: "senior-gas-engineer-lpg-sng",
    title: "Senior Gas Engineer (LPG/SNG)",
    location: "Dubai",
    type: "Full-time",
    about:
      "GASIS is seeking a Senior Gas Engineer specializing in LPG/SNG systems to lead engineering projects and ensure the highest standards of safety and compliance across all gas infrastructure deployments.",
    responsibilities: [
      "Design and oversee LPG/SNG distribution systems for residential and commercial developments",
      "Review and approve engineering drawings and technical specifications",
      "Ensure compliance with DCD, ESMA, and international gas safety standards",
      "Mentor junior engineers and technicians",
      "Liaise with government authorities for project approvals and inspections",
    ],
    requirements: [
      "Bachelor's degree in Mechanical or Chemical Engineering",
      "Minimum 7 years of experience in LPG/SNG engineering",
      "Professional Engineering certification preferred",
      "Deep knowledge of UAE gas regulations and DCD requirements",
      "Strong leadership and project management skills",
    ],
    offering: [
      "Senior-level compensation package",
      "Medical insurance for employee and dependents",
      "Professional certification sponsorship",
      "Leadership development programs",
      "Annual leave as per UAE Labour Law",
    ],
  },
  {
    slug: "smart-meter-installation-technician",
    title: "Smart Meter Installation Technician",
    location: "Dubai",
    type: "Full-time",
    about:
      "Join our technology-forward team as a Smart Meter Installation Technician. You will play a key role in deploying and maintaining smart metering systems that enable real-time gas consumption monitoring for our customers.",
    responsibilities: [
      "Install, configure, and commission smart gas meters at customer sites",
      "Perform routine maintenance and troubleshooting of metering equipment",
      "Ensure data connectivity between meters and the central monitoring platform",
      "Train customers on meter reading and portal access",
      "Document all installations and report any anomalies",
    ],
    requirements: [
      "Diploma or degree in Electrical/Electronics Engineering",
      "Experience with IoT devices and smart metering systems",
      "Knowledge of gas metering standards and calibration",
      "Strong technical aptitude and attention to detail",
      "Valid UAE driving license",
    ],
    offering: [
      "Competitive salary with performance bonuses",
      "Comprehensive medical coverage",
      "Training on latest smart metering technologies",
      "Career growth into supervisory roles",
      "Paid annual leave and public holidays",
    ],
  },
  {
    slug: "safety-inspector-esma-certified",
    title: "Safety Inspector (ESMA Certified)",
    location: "Dubai",
    type: "Full-time",
    about:
      "GASIS requires an ESMA-certified Safety Inspector to conduct regular safety audits, ensure compliance with national gas safety regulations, and maintain our industry-leading safety record.",
    responsibilities: [
      "Conduct scheduled and unscheduled safety inspections across all GASIS sites",
      "Identify safety hazards and recommend corrective actions",
      "Prepare detailed inspection reports and compliance documentation",
      "Ensure adherence to ESMA, DCD, and HSE standards",
      "Investigate incidents and near-misses, providing root cause analysis",
    ],
    requirements: [
      "ESMA Compliance Certification",
      "Minimum 5 years of experience in safety inspection (gas/utilities preferred)",
      "NEBOSH or IOSH certification is a plus",
      "Excellent report writing and analytical skills",
      "Familiarity with UAE occupational health and safety regulations",
    ],
    offering: [
      "Competitive salary reviewed annually",
      "Medical insurance for staff and dependents",
      "HSE certification renewal support",
      "Performance-based bonuses tied to safety KPIs",
      "Structured career development pathway",
    ],
  },
  {
    slug: "customer-support-agent",
    title: "Customer Support Agent",
    location: "Dubai",
    type: "Full-time",
    about:
      "We are looking for a friendly and efficient Customer Support Agent to handle customer inquiries, billing questions, and service requests through our multi-channel support center.",
    responsibilities: [
      "Handle inbound calls, emails, and chat inquiries from residential and commercial customers",
      "Assist with billing inquiries, payment processing, and account updates",
      "Log and escalate service requests, complaints, and emergency reports",
      "Provide information about GASIS services, tariffs, and new connections",
      "Follow up on open tickets to ensure timely resolution",
    ],
    requirements: [
      "Diploma or degree in any field",
      "Minimum 2 years of customer service experience",
      "Fluent in English; Arabic is a strong advantage",
      "Proficiency in CRM systems and MS Office",
      "Excellent communication and problem-solving skills",
    ],
    offering: [
      "Market-aligned salary",
      "Medical insurance",
      "Shift allowances where applicable",
      "Training and development programs",
      "Friendly and supportive work environment",
    ],
  },
  {
    slug: "billing-collections-officer",
    title: "Billing & Collections Officer",
    location: "Dubai",
    type: "Full-time",
    about:
      "GASIS is hiring a Billing & Collections Officer to manage customer billing cycles, ensure accurate invoicing, and handle collections for our growing customer base.",
    responsibilities: [
      "Generate and distribute monthly invoices to residential and commercial customers",
      "Monitor outstanding balances and follow up on overdue accounts",
      "Process payments, refunds, and account adjustments",
      "Reconcile billing records with meter reading data",
      "Prepare monthly collections reports for management review",
    ],
    requirements: [
      "Bachelor's degree in Accounting, Finance, or related field",
      "Minimum 3 years of experience in billing or collections",
      "Experience with utility billing systems is preferred",
      "Strong numerical and analytical skills",
      "Proficiency in ERP systems and Excel",
    ],
    offering: [
      "Competitive salary package",
      "Medical insurance",
      "Performance bonuses based on collection targets",
      "Professional development opportunities",
      "Annual leave as per UAE Labour Law",
    ],
  },
  {
    slug: "hr-generalist",
    title: "HR Generalist",
    location: "Dubai",
    type: "Full-time",
    about:
      "We are seeking an experienced HR Generalist to support our growing team with recruitment, employee relations, compliance, and day-to-day HR operations.",
    responsibilities: [
      "Manage end-to-end recruitment for technical and administrative positions",
      "Administer employee onboarding and offboarding processes",
      "Maintain HR records and ensure compliance with UAE Labour Law",
      "Handle employee relations, grievances, and disciplinary matters",
      "Coordinate training programs and performance review cycles",
    ],
    requirements: [
      "Bachelor's degree in HR Management or related field",
      "Minimum 4 years of HR generalist experience in the UAE",
      "Knowledge of UAE Labour Law and visa processing",
      "CIPD or SHRM certification is a plus",
      "Strong interpersonal and organizational skills",
    ],
    offering: [
      "Competitive salary",
      "Medical insurance for employee and dependents",
      "HR certification sponsorship",
      "Career growth within a rapidly expanding company",
      "Annual leave and public holidays",
    ],
  },
  {
    slug: "accountant-utility-billing",
    title: "Accountant (Utility Billing Experience)",
    location: "Dubai",
    type: "Full-time",
    about:
      "GASIS is looking for an Accountant with utility billing experience to manage financial records, prepare reports, and ensure accuracy across all billing and accounting functions.",
    responsibilities: [
      "Manage accounts receivable and payable for utility billing operations",
      "Prepare monthly financial statements and reconciliation reports",
      "Ensure VAT compliance and timely filing with the FTA",
      "Reconcile customer billing with payment collections",
      "Support external audits and regulatory reporting",
    ],
    requirements: [
      "Bachelor's degree in Accounting or Finance",
      "Minimum 4 years of accounting experience (utility sector preferred)",
      "Knowledge of UAE VAT regulations",
      "Proficiency in accounting software (QuickBooks, SAP, or similar)",
      "CPA or ACCA qualification is a plus",
    ],
    offering: [
      "Competitive salary reviewed annually",
      "Comprehensive medical insurance",
      "Professional certification support",
      "Performance bonuses",
      "Structured career development",
    ],
  },
  {
    slug: "it-support-portal-administrator",
    title: "IT Support / Portal Administrator",
    location: "Dubai",
    type: "Full-time",
    about:
      "We need an IT Support / Portal Administrator to maintain our customer-facing online portal, provide internal IT support, and ensure smooth digital operations across the organization.",
    responsibilities: [
      "Administer and maintain the GASIS customer portal and internal systems",
      "Provide first-line IT support to staff across all departments",
      "Monitor system uptime, troubleshoot issues, and coordinate with vendors",
      "Manage user accounts, permissions, and security protocols",
      "Support the deployment of new digital tools and integrations",
    ],
    requirements: [
      "Bachelor's degree in IT, Computer Science, or related field",
      "Minimum 3 years of IT support or system administration experience",
      "Experience with web portals, CMS, and cloud platforms",
      "Knowledge of cybersecurity best practices",
      "Strong troubleshooting and communication skills",
    ],
    offering: [
      "Competitive salary",
      "Medical insurance",
      "IT certification sponsorship",
      "Exposure to smart utility technology platforms",
      "Career advancement opportunities",
    ],
  },
  {
    slug: "business-development-executive",
    title: "Business Development Executive",
    location: "Dubai",
    type: "Full-time",
    about:
      "GASIS is expanding and we need a Business Development Executive to identify new opportunities, build relationships with developers and owners' associations, and drive growth across our commercial and residential segments.",
    responsibilities: [
      "Identify and pursue new business opportunities in gas supply and services",
      "Build and maintain relationships with property developers, OAs, and commercial clients",
      "Prepare proposals, presentations, and pricing for prospective clients",
      "Collaborate with engineering and operations teams on project feasibility",
      "Track market trends and competitor activity in the UAE utilities sector",
    ],
    requirements: [
      "Bachelor's degree in Business, Marketing, or related field",
      "Minimum 4 years of business development experience (utilities or real estate preferred)",
      "Strong networking and negotiation skills",
      "Excellent presentation and proposal writing abilities",
      "Valid UAE driving license",
    ],
    offering: [
      "Base salary plus commission structure",
      "Medical insurance",
      "Company vehicle or car allowance",
      "Performance bonuses",
      "Professional development and training",
    ],
  },
  {
    slug: "partnership-manager-developers-oas",
    title: "Partnership Manager (Developers/OAs)",
    location: "Dubai",
    type: "Full-time",
    about:
      "We are looking for a Partnership Manager to manage and grow relationships with property developers and owners' associations, ensuring long-term partnerships and seamless gas service delivery.",
    responsibilities: [
      "Manage a portfolio of developer and OA partnerships",
      "Negotiate service agreements and ensure contractual compliance",
      "Act as the primary point of contact for partner escalations and service issues",
      "Coordinate with internal teams to deliver projects on time and to specification",
      "Identify upselling and cross-selling opportunities within existing partnerships",
    ],
    requirements: [
      "Bachelor's degree in Business Administration or related field",
      "Minimum 5 years of account management or partnership experience in the UAE",
      "Experience in real estate, utilities, or facilities management sectors",
      "Strong relationship management and conflict resolution skills",
      "Fluent in English; Arabic is a strong advantage",
    ],
    offering: [
      "Senior-level compensation",
      "Medical insurance for employee and dependents",
      "Performance bonuses tied to partnership KPIs",
      "Company vehicle or car allowance",
      "Leadership development programs",
    ],
  },
];

export function getJobBySlug(slug: string): Job | undefined {
  return jobs.find((job) => job.slug === slug);
}

export function getApplyMailtoLink(job: Job): string {
  const subject = encodeURIComponent(`Application for ${job.title} – GASIS Careers`);
  const body = encodeURIComponent(
    `Dear GASIS HR Team,\n\nI am writing to express my interest in the ${job.title} position (${job.location}, ${job.type}) as listed on your careers page.\n\nPlease find my CV attached.\n\nI look forward to hearing from you.\n\nBest regards,\n[Your Name]\n[Your Phone Number]`
  );
  return `mailto:careers@gasis.ae?subject=${subject}&body=${body}`;
}
